import vert from './glsl/videofade.vert.glsl';
import frag from './glsl/videofade.frag.glsl';
export default { frag, vert };